import { Box } from '@material-ui/core';
import { Channel } from '@nemuru-eng/js-api-client';

import { ChannelTypeIcons } from '@/components/modules/MerchantDetail/MerchantStructure/constants/ChannelTypeIcons';
import { AddNewUser } from '@/components/modules/Users/components/AddNewUser/AddNewUser';
import { UserCredentialsType } from '@/components/modules/Users/types/UserCredentials';
import { ChannelOrAgentDropdownSelector } from '@/components/shared/components/AgentSelectionComponent/components/ChannelOrAgentDropdownSelector';
import { ChannelMap } from '@/components/shared/components/AgentSelectionComponent/maps/channel.map';
import { SelectItem } from '@/components/shared/components/AgentSelectionComponent/types/SelectItem';
import { SubSectionWrapper } from '@/components/shared/components/SubSectionWrapper';
import { Text } from '@/components/shared/components/Text';
import { ModuleCorePermissionProps } from '@/config/types';

interface ChannelSelectorProps extends ModuleCorePermissionProps {
  setSelectedChannel: (channel: Channel | undefined) => void;
  selectedChannel: Channel | undefined;
  allChannels: Channel[] | undefined;
  isUserMerchant?: boolean;
}

export const ChannelSelector = ({
  canEdit,
  setSelectedChannel,
  selectedChannel,
  allChannels,
  isUserMerchant,
}: ChannelSelectorProps) => {
  let channelItem: SelectItem | undefined;

  if (selectedChannel) {
    channelItem = ChannelMap.toSelectItem(selectedChannel);
  }

  if (!allChannels) return null;

  return (
    <SubSectionWrapper title="CHANNEL">
      <Box display={'flex'} flexDirection={'column'} gridGap={16}>
        <ChannelOrAgentDropdownSelector
          disabled={!isUserMerchant}
          title={<></>}
          subtitle={<Text tId={'SELECT_A_CHANNEL'} />}
          icon={selectedChannel ? ChannelTypeIcons[selectedChannel.type] : 'storefront'}
          value={channelItem}
          items={allChannels?.map(ChannelMap.toSelectItem) as SelectItem[]}
          handleClickItem={(item) => setSelectedChannel(allChannels?.find((channel) => channel.id === item.id))}
        />
        <Box>
          {canEdit && isUserMerchant && (
            <AddNewUser selectedChannel={selectedChannel} type={UserCredentialsType.CHANNEL} />
          )}
        </Box>
      </Box>
    </SubSectionWrapper>
  );
};
